/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateImporterDto
 */
export interface UpdateImporterDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateImporterDto
     */
    description?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateImporterDto
     */
    blacklist?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateImporterDto
     */
    isEnabled?: boolean;
}

export function UpdateImporterDtoFromJSON(json: any): UpdateImporterDto {
    return UpdateImporterDtoFromJSONTyped(json, false);
}

export function UpdateImporterDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateImporterDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': !exists(json, 'description') ? undefined : json['description'],
        'blacklist': !exists(json, 'blacklist') ? undefined : json['blacklist'],
        'isEnabled': !exists(json, 'isEnabled') ? undefined : json['isEnabled'],
    };
}

export function UpdateImporterDtoToJSON(value?: UpdateImporterDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': value.description,
        'blacklist': value.blacklist,
        'isEnabled': value.isEnabled,
    };
}

